<div class="title-bar">
    <span class="title">Welcome</span>
</div>
